import Examination from '@/enums/Examination';

const colors = {
    [Examination.APPROVED]: '#00A03C',
    [Examination.REINSPECTION]: '#FF9100',
    [Examination.REJECTED]: '#EC0000',
};

export default colors;
